export default "__VITE_ASSET__BJx_995t__"